import React from "react"

import { HelpCircle } from "lucide-react"
import { Control } from "react-hook-form"

import { FormControl, FormField, FormItem } from "@/components/ui/form"
import { Label } from "@/components/ui/label"
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip"

import SectionHeader from "./SectionHeader"

interface AdditionalTrialSectionProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>
}

const AdditionalTrialSection: React.FC<AdditionalTrialSectionProps> = ({ control }) => {
  return (
    <div className="space-y-2">
      <SectionHeader title="Additional Trial Required">
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <HelpCircle className="h-4 w-4 text-palette-jungleGreen400" />
            </TooltipTrigger>
            <TooltipContent className="max-w-xs">
              Selecting 'No' will move the person to either the next stage or rejected based on the
              review.
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </SectionHeader>
      <FormField
        control={control}
        name="requireAnotherTrial"
        render={({ field }) => (
          <FormItem className="flex flex-row items-center space-x-3 space-y-0">
            <FormControl>
              <RadioGroup
                onValueChange={(value) => field.onChange(value === "yes")}
                defaultValue={field.value ? "yes" : "no"}
                className="flex space-x-4"
              >
                <div className="flex items-center space-x-2">
                  <RadioGroupItem value="yes" id="yes" />
                  <Label htmlFor="yes">Yes</Label>
                </div>
                <div className="flex items-center space-x-2">
                  <RadioGroupItem value="no" id="no" />
                  <Label htmlFor="no">No</Label>
                </div>
              </RadioGroup>
            </FormControl>
          </FormItem>
        )}
      />
    </div>
  )
}

export default AdditionalTrialSection
